import { render, staticRenderFns } from "./addCoApplicant.vue?vue&type=template&id=5d2f0b6c"
import script from "./addCoApplicant.vue?vue&type=script&lang=js"
export * from "./addCoApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports